export default __webpack_public_path__ + "static/18_35-44f430e175fc94acdbde435fa461b477.png";